import Api from 'libs/api';

class UsersApi extends Api {
  constructor() {
    super('admin/users/');
  }
}

export default UsersApi;
